import { render, staticRenderFns } from "./EditWaiverPage.vue?vue&type=template&id=150673a8&scoped=true&"
import script from "./EditWaiverPage.vue?vue&type=script&lang=js&"
export * from "./EditWaiverPage.vue?vue&type=script&lang=js&"
import style0 from "./EditWaiverPage.vue?vue&type=style&index=0&id=150673a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150673a8",
  null
  
)

export default component.exports